const OnboardingAlert = ({onClose}) => (
  <div className="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Get started by listening to the podcasts below</strong>
    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={onClose}>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
)

export default OnboardingAlert;
